import { render, staticRenderFns } from "./PDFHeader.vue?vue&type=template&id=47920ffa&scoped=true"
import script from "./PDFHeader.vue?vue&type=script&lang=js"
export * from "./PDFHeader.vue?vue&type=script&lang=js"
import style0 from "./PDFHeader.vue?vue&type=style&index=0&id=47920ffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47920ffa",
  null
  
)

export default component.exports